import React, { useState } from "react";
import { Transaction_Action } from "../../Connections/Transaction";

import Toast from "../../Utils/Toast";

import "../../Styles/ActionModal.css";
import LoadingSpinner from "./LoadingSpinner";
import { Link } from "react-router-dom";

const ActionModal = ({ close, bookId, campaignActionId, getBook }) => {
  const [title, setTitle] = useState();
  const [description, setDescription] = useState();
  const [file, setFile] = useState();

  const [loading, setLoading] = useState(false);

  // =====================================================

  const handleSubmitAddActionForm = (e) => {
    e.preventDefault();
    if (title) {
      if (description?.split(" ").length <= 40) {
        if (file) {
          const form = new FormData();

          form.append("Title", title);
          form.append("CampaignActionId", campaignActionId);
          form.append("File", file);
          form.append("Description", description);
          form.append("BookId", bookId);

          setLoading(true);

          Transaction_Action.AddAction(form)
            .then((res) => {
              if (res[0]) {
                Toast("success", "کنش شما با موفقیت ثبت شد!");
                getBook();
                close();
              } else {
                Toast("error", res[1]);
              }
              setLoading(false);
            })
            .catch((err) => {
              setLoading(false);
            });
        } else {
          Toast("error", "لطفا فایل خود را آپلود کنید.");
        }
      } else {
        Toast("error", "در مورد اثرت خیلی بلند حداکثر 3تا5 خط توضیح بده.");
      }
    } else {
      Toast("error", "برای کاری که تولید کردی یه اسم انتخاب کن.");
    }
  };

  // =====================================================

  return (
    <div className="modal-wrapper">
      <div className="ActionModalClose" onClick={close}></div>
      <div className="Actionmodal">
        <div className="Actionmodal-inside">
          <svg
            onClick={close}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="white"
            className="Actionmodal-close-icon"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>

          <form
            onSubmit={handleSubmitAddActionForm}
            className="Actionmodal-inside-form"
            encType="multipart/form-data"
          >
            <label className="Actionmodal-inside-form-label1">
              برای کاری که تولید کردی یه اسم انتخاب کن
            </label>
            <input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              type="text"
              className="Actionmodal-inside-form-input1"
            />
            <label className="Actionmodal-inside-form-label2">
              در مورد اثرت خیلی کوتاه حداکثر 3تا5 خط توضیح بده.
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="Actionmodal-inside-form-input2 number-font"
              rows={4}
              minLength={1}
            ></textarea>
            <input
              hidden
              id="file-input"
              type="file"
              onChange={(e) => setFile(e.target.files[0])}
              className="Actionmodal-inside-form-input3"
              accept="png,jpg,mp3,mp4"
            />
            <label
              htmlFor="file-input"
              className="Actionmodal-inside-form-input3-inside"
            >
              <img
                className="Actionmodal-inside-form-input3-img"
                src="/imgs/common/ActionModal.svg"
              />
              <p className="Actionmodal-inside-form-input3-text1">
                {file
                  ? file.name.length > 30
                    ? file.name.substring(0, 30) + "..."
                    : file.name
                  : "فایل رو اینجا آپلود کن"}
              </p>
              {!file ? (
                <p className="Actionmodal-inside-form-input3-text2 number-font">
                  {campaignActionId == 5
                    ? `
                                    اینجا پوستر یا عکس نوشتت رو با فرمت jpg و حجم حداکثر 3 مگابایت برامون بفرست.
                                    `
                    : campaignActionId == 7
                    ? `
                                    اینجا نقاشی یا کمیکت رو با فرمت jpg و حجم حداکثر 3 مگابایت برامون بفرست.
                                    `
                    : campaignActionId == 8
                    ? `
                                    اینجا چت استوری رو با فرمت jpg و حجم حداکثر 2 مگابایت برامون بفرست.
                                    `
                    : campaignActionId == 9
                    ? `
                                    اینجا پادکستت رو با فرمت mp3 و حجم حداکثر 7 مگابایت برامون بفرست.
                                    `
                    : null}
                </p>
              ) : null}
            </label>
            <p
              style={{
                marginTop: "12px",
                marginBottom: "4px",
                fontSize: "14px",
              }}
              className="Login_wrapper-right-side-container-footer-text"
            >
              به راهنمایی احتیاج داری !
              <Link
                className="Login_wrapper-right-side-container-footer-text-register"
                to="/hisstori/blog/guide"
              >
                راهنما
              </Link>
            </p>
            {loading ? (
              <div
                style={{ display: "flex", justifyContent: "center" }}
                className="Actionmodal-inside-form-btn"
              >
                <LoadingSpinner />
              </div>
            ) : (
              <button className="Actionmodal-inside-form-btn" type="submit">
                ارسال
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};
export default ActionModal;
